<template lang="pug">
  .service-container
    .service-container__header.service-container__header__bg2
      .service-container__title {{ $t('营销人才服务') }}

      .service-container__desc {{ $t('专注营销行业的人才服务') }}
      .service-container__desc {{ $t('帮助企业客户连接并匹配充满才华的营销人才。') }}
      .service-container__tab__bg
        //- .service-container__tab
        //-   .tab__title(
        //-     @click="activeIndex = 0"
        //-   )
        //-     span {{ $t('Freelancer') }}
        //-     .tab__arrow(v-show="activeIndex === 0")
        //-   .tab__title(
        //-     @click="activeIndex = 1"
        //-   )
        //-     span {{ $t('全职') }}
        //-     .tab__arrow(v-show="activeIndex === 1")
        //-   .tab__title(
        //-     @click="activeIndex = 2"
        //-   )
        //-     span {{ $t('支付解决方案') }}
        //-     .tab__arrow(v-show="activeIndex === 2")
    tax(v-if="activeIndex === 0")
    launch(v-if="activeIndex === 1")
    pay(v-if="activeIndex === 2")
    MobileContact
</template>

<script>
import Launch from './components/Launch'
import Tax from './components/Tax'
import Pay from "./components/Pay";
import MobileContact from '@/components/MobileContact'
export default {
  components: {
    Launch,
    Tax,
    Pay,
    MobileContact
  },
  data () {
    return {
      activeIndex: 0
    }
  },
  watch: {
    '$route': {
      handler (nv, ov) {
        if (nv && nv.query.activeIndex && ((ov && nv.query.activeIndex !== ov.query.activeIndex) || !ov)) {
          this.activeIndex = Number(this.$route.query.activeIndex)
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
